import { UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { CrmAuthLoginMessages, CrmBaseLoginComponent, CrmBaseLoginData, CrmLoginProvider } from '@touch4it/ng-swp/auth';
import { CrmFormComponent, CrmFormProvider } from '@touch4it/ng-swp/form';
import { CrmMessageService } from '@touch4it/ng-swp/message';
import { CrmTranslatePipe } from '@touch4it/ng-swp/translate';
import { NzButtonComponent } from 'ng-zorro-antd/button';

import { environment } from '~/envs/environment';

@Component({
  selector: 'app-login-content',
  template: `
    <crm-form [provider]="formProvider" (formSubmitted)="handleSubmit()"></crm-form>
    <button
      class="crm-login--login-button"
      nz-button
      nzBlock
      id="login"
      nzType="primary"
      [disabled]="isLoading()"
      [nzLoading]="isLoading()"
      (click)="handleSubmit()"
    >
      {{ messages.submit ?? 'auth.login.submit' | crmTranslate | uppercase }}
    </button>

    @if (showAzureSso) {
      <button
        class="crm-login--azure-sso-button"
        nz-button
        nzBlock
        id="azure-sso-login"
        nzType="default"
        [disabled]="isAzureSsoLoading()"
        [nzLoading]="isAzureSsoLoading()"
        (click)="handleAzureSso()"
      >
        {{ 'auth.login.azureSso' | crmTranslate | uppercase }}
      </button>
    }

    <button
      class="crm-login--forgotten-password"
      nz-button
      nzBlock
      id="forgotten-password"
      nzType="text"
      (click)="handleForgottenPassword()"
    >
      {{ messages.forgottenPassword ?? 'auth.actions.forgottenPassword' | crmTranslate | uppercase }}
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CrmFormComponent, NzButtonComponent, CrmTranslatePipe, UpperCasePipe],
})
export class LoginContentComponent extends CrmBaseLoginComponent implements OnInit {
  override readonly provider!: CrmLoginProvider;
  override readonly formProvider!: CrmFormProvider<CrmBaseLoginData>;
  override readonly messages!: CrmAuthLoginMessages;
  override readonly showForgottenPassword?: boolean;

  readonly showAzureSso = Boolean(environment.azureSsoUrl);
  readonly isAzureSsoLoading = signal(false);

  private readonly messageService = inject(CrmMessageService);

  ngOnInit() {
    const error = this.route.snapshot.queryParamMap.get('error');
    if (error) {
      this.messageService.error(error);
    }
  }

  protected handleAzureSso() {
    if (!environment.azureSsoUrl) {
      return;
    }

    this.isAzureSsoLoading.set(true);
    window.location.assign(environment.azureSsoUrl);
  }
}
